import styles from './styles/Items.module.scss';
import React from 'react';
import { PER_ROW_LESS } from '../../constants/perRowKeys';
import { nbItemsPerPage } from '../../configs';
import { ProductCardSkeleton } from '../../../Components/react/ProductCardVNode';
const arr = [...Array(nbItemsPerPage)];
export const ItemsSkeleton = ({ perRow }) => {
    const perRowClass = perRow === PER_ROW_LESS
        ? styles.itemsLess
        : styles.itemsMore;
    return (React.createElement("ul", { className: `list:none d:grid ${styles.items} ${perRowClass}` }, arr.map((v, i) => (React.createElement("li", { key: i, style: { order: 1 } },
        React.createElement(ProductCardSkeleton, null))))));
};
